import { gql } from "@apollo/client";

export const typeDef = gql`
  type PinActivateResult @cacheControl(scope: PRIVATE, maxAge: 0) {
    status: String
    result: Boolean
    deviceToken: String
  }

  type Mutation {
    pinActivate(code: String): PinActivateResult
  }
`;

export const resolvers = {
  Mutation: {
    pinActivate: async (_parent, { code }, { dataSources }) => {
      try {
        const res = await dataSources.pinManager.pinActivate(code);
        return {
          status: res?.status,
          result: res?.result,
          deviceToken: res?.device_token,
        };
      } catch (e) {
        console.log("pinActivate schema error in resolver", e);
        return {
          result: false,
        };
      }
    },
  },
};
